import { api } from "@/lib/api"
import { WorkspaceStackedBarChart } from "./workspace-stacked-bar-chart"

export function AIAutoRepliesChart() {
	const query = api.analytics.aiAutoRepliesChart.useQuery({})

	return (
		<WorkspaceStackedBarChart
			title="AI Auto-Replies"
			data={query.data}
			isLoading={query.isLoading}
		/>
	)
}
